import { render, staticRenderFns } from "./SlotMachine.vue?vue&type=template&id=6be7e7a3&scoped=true"
import script from "./SlotMachine.vue?vue&type=script&lang=js"
export * from "./SlotMachine.vue?vue&type=script&lang=js"
import style0 from "./SlotMachine.vue?vue&type=style&index=0&id=6be7e7a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be7e7a3",
  null
  
)

export default component.exports